//@ts-ignore
import FileDownload from "js-file-download";
export const DownloadFile = (data, file_name) => {
    return FileDownload(data, file_name);
};
